import { isEmpty } from 'utils/types';

const getAddressLabel = (address = {}) =>
  address.isZipcode
    ? address.zipcode
    : `${address.company_name || ''}` +
      (!!address.label ? ` - ${address.label}` : '');

const getAddressFullData = (address = {}) => {
  const contactName = address.contactName || '';
  const contactPhone = address.contactPhone || '';

  const contactString =
    !isEmpty(contactName) || !isEmpty(contactPhone)
      ? `· ${contactName} ${contactPhone}`
      : '';

  return `${address.addressLine}, ${address.zipcode} ${contactString}`;
};

const formatCompaniesByStopType = (stops, stopType, t) => {
  const companies =
    stopType === 'dropoff'
      ? stops.map((stop) => stop.address.company_name).slice(1)
      : stops
          .map((stop) => stop.address.company_name)
          .slice(0, stops.length - 1);
  return companies.length >= 2
    ? companies.slice(0, -1).join(t('comma')) +
        t('and') +
        companies[companies.length - 1]
    : companies[0];
};

export default {
  getAddressLabel,
  getAddressFullData,
  formatCompaniesByStopType,
};
